module.exports = __webpack_public_path__ + "static/media/Arcade_6510.ec61324e.jpg";